<template>
    <div class="ball" :style="`transform: scale(${this.ballScall}); background: ${this.color};`"></div>
</template>

<script>
// helpful web audio math
import { createAudioMeter } from '@/js/volume-meter';

function mapRange(value, low1, high1, low2, high2) {
  // helpful function taken from Processing + P5 lands...
  // eslint-disable-next-line no-mixed-operators
  return low2 + (high2 - low2) * (value - low1) / (high1 - low1);
}

export default {
  name: 'FilterBall',
  props: {
    center: {
      type: Number,
    },
    color: {
      type: String,
    },
    filter: {
      type: String,
    },

  },
  data() {
    return {
      vol: 0,
      volScaler: 60,
      mediaStreamSource: null,
      audioContext: null,
    };
  },
  computed: {
    ballScall() {
      return mapRange(this.vol, 0.0, 2.0, 0.5, 1.0);
    },
  },
  mounted() {
    let intervalCount = 0;
    const int = setInterval(() => {
      console.log('blocking for userMediaStreamSource');
      intervalCount += 1;
      if (window.userMediaStreamSource) {
        clearInterval(int);
        console.log('stream source acquired!  moving on');
        this.startFilterBall();
      } else if (intervalCount > 300) {
        clearInterval(int);
        console.log('waited for context for 6 seconds, giving up....');
      }
    }, 300);
  },
  methods: {

    findPeak(array) {
      let peak = 0;
      array.forEach((value) => {
        peak = Math.max(peak, Math.abs(value));
      });
      return peak;
    },

    startFilterBall() {
      console.log(`startFilterBall called ${typeof (this.center)}`);

      const biquadFilter = window.audioContext.createBiquadFilter();
      biquadFilter.type = this.filter;
      biquadFilter.frequency.value = this.center;
      biquadFilter.Q.value = 10;

      // const gainNode = window.audioContext.createGain();
      // gainNode.gain.value = 2.5;

      // Create a new volume meter and connect it.
      this.meter = createAudioMeter(window.audioContext);


      window.userMediaStreamSource.connect(biquadFilter);
      // biquadFilter.connect(window.audioContext.destination);
      biquadFilter.connect(this.meter);
      // gainNode.connect(window.audioContext.destination);

      // gainNode.connect(this.meter);

      this.meter.connect(window.audioContext.destination);


      // kick off the visual updating
      this.drawLoop();
    },

    drawLoop() {
      // console.log('drawLoop started');
      this.vol = this.meter.volume * this.volScaler;
      this.$emit('volume', this.meter.volume);
      // efficient loop
      window.requestAnimationFrame(this.drawLoop);
    },
  },
};
</script>

<style scoped>
.ball {
    background: rgba(255,0,0,0.9);
    width: 50px;
    height: 50px;
    border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/FilterBall.vue